import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TipoRelacao } from '@core/models/entidade';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { EntidadesService } from '@core/services/entidades.service';
import { MandatoService } from '@core/services/mandato.service';
import { MessageService } from '@core/services/message.service';
import { ColumnOrder } from '@core/table/order';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { addFormControls, converterItensVaziosEmNull, dataComDigitacao } from '@shared/util/util';
import dayjs from 'dayjs';

@Component({
  selector: 'app-mandato-list',
  templateUrl: './mandato-list.component.html',
  styleUrls: ['./mandato-list.component.scss']
})
export class MandatoListComponent implements OnInit, OnChanges {

  @Input() entidadeForm!: FormGroup;
  @Input() data: any;
  @Input() nomePagina!: NomePaginaEnum;
  mandatoForm!: FormGroup;

  @Input() tipoEntidadeSelecionada!: any;
  @Input() tipoEntidadeList!: any;

  idParams!: number;
  editar: boolean = false;
  desassociar: boolean = false;

  dataSet: any[]=[];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;
  nzFilterOption = (): boolean => true;

  mandatoList: any;
  @Input() tipoRelacaoList: any[] = [];
  idTipoRelacaoEntidadeSelecionada: any;
  isOrganizacao: boolean = false;

  isShowDataAssociacao: boolean = false;
  isShowDataDesassociacao: boolean = false;
  mandatoSelecionada: any;
  indexItemAtual: number | undefined;

  @Input() somenteVisualizar!: any;

  constructor(
    private mandatoService: MandatoService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnChanges(): void {
    this.idParams = this.data?.id;
    this.carregarTabela();
  }

  ngOnInit() {
    this.construirForm();
  }

  construirForm() {
    const nomeObs =  'mandato';
    addFormControls(this.entidadeForm, {
      [nomeObs]: [''],
    });

    this.mandatoForm = this.fb.group({
      id: [''],
      entidadeId: [''],
      dataCadastro: [''],
      dataInicioMandato: [''],
      dataFimMandato: [''],
      justificativa: [''],

   }, { validators: this.validarDatas });
  }

  validarDatas(formGroup: FormGroup) {
    const dataInicio = formGroup.get('dataInicioMandato')?.value;
    const dataFim = formGroup.get('dataFimMandato')?.value;

    if (dataInicio && dataFim && dayjs(dataInicio).isAfter(dayjs(dataFim))) {
      return { dataInvalida: true };
    }

    return null;
  }

  submit() {
    let objForm = { ...this.mandatoForm.getRawValue() };
    objForm.entidadeId = Number(this.idParams);

    objForm.dataInicioMandato = objForm.dataInicioMandato ? dayjs(objForm.dataInicioMandato).toISOString() : null;
    objForm.dataFimMandato = objForm.dataFimMandato ? dayjs(objForm.dataFimMandato).toISOString() : null;

    switch (true) {
      case this.desassociar:
        this.deleteMandato(objForm);
        break;
      case this.editar:
        this.editarMandato(objForm);
        break;
      default:
        this.salvarMandato(objForm);
        break;
    }
  }

  salvarMandato(objEnvio: any) {
    if (objEnvio.entidadeId) {
      objEnvio.id =  objEnvio.id?.id;
      objEnvio.dataInicioMandato = objEnvio.dataInicioMandato ? dayjs(objEnvio.dataInicioMandato).toISOString() : null;
      objEnvio.dataFimMandato = objEnvio.dataFimMandato ? dayjs(objEnvio.dataFimMandato).toISOString() : null;
      objEnvio = converterItensVaziosEmNull(objEnvio);

      this.mandatoService.salvarMandato(objEnvio).subscribe(() => {
        this.messageService.success('Mandato salva com sucesso!');
        this.reset();
        this.carregarTabela();
      });
    } else {
      objEnvio.dataInicioMandato = objEnvio.dataInicioMandato ? dayjs(objEnvio.dataInicioMandato).toISOString() : null;
      objEnvio.dataFimMandato = objEnvio.dataFimMandato ? dayjs(objEnvio.dataFimMandato).toISOString() : null;
      objEnvio = converterItensVaziosEmNull(objEnvio);

      if (!this.dataSet) {
        this.dataSet = [];
      }

      this.dataSet.push(objEnvio);
      this.reset();
      this.enviarMandato();
    }
  }

  editarMandato(objEnvio: any) {
    if (objEnvio.entidadeId) {
      objEnvio = converterItensVaziosEmNull(objEnvio);
      this.mandatoService.editarMandato(objEnvio.id, objEnvio).subscribe(() => {
        this.messageService.success('Mandato editada com sucesso!');
        this.reset();
        this.carregarTabela();
      });
    } else {
      if (this.indexItemAtual !== undefined) {
        this.dataSet[this.indexItemAtual] = objEnvio;
        this.indexItemAtual = undefined;
        this.reset();
      }
      this.enviarMandato();
    }
  }

  deleteMandato(objEnvio: any) {
    this.mandatoService.deleteMandato(objEnvio).subscribe(() => {
      this.messageService.success('Mandato deletado com sucesso!');
      this.carregarTabela();
    });
  }

  carregarTabela() {
    if (this.idParams) {
      this.mandatoService.consultarPorEntidade(this.idParams).subscribe((mandatos: any) => {
        this.cdr.detectChanges();
        this.dataSet = mandatos;
        // this.paginator.totalItens = mandatos.totalElements;
        this.enviarMandato();
      });
    } else {
      this.dataSet = this.entidadeForm.get('mandatos')?.value;
    }
  }

  editarItem(item: any, index?: number) {
    this.editar = true;
    this.indexItemAtual = index;
    this.mandatoForm.patchValue(item);
  }

  desassociarItem(item: any) {
    this.desassociar = true;
    this.editar = false;
    this.mandatoForm.patchValue(item);
  }

  removerItem(item: any) {
    if (!item.id) {
      const index: number = this.dataSet.findIndex((i: any) => i === item);
      if (index !== -1) {
        this.dataSet.splice(index, 1);
      }
      this.enviarMandato();
    }
  }

  reset() {
    this.mandatoForm.reset();
    this.editar = false;
    this.desassociar = false;
  }

  sort(event: any) {
    let column = event.sort.find((x: any) => x.value);
    if (column) {
      let order = new ColumnOrder();
      order.value = column.value;
      order.key = column.key;
      this.columOrder = order;
    }
    else {
      this.columOrder = undefined;
      this.dataSet = this.dataSet;
    }
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean') {
      return b === 'true' || a === b;
    }
    else {
      return a === b;
    }
  }

  enviarMandato() {
    this.cdr.detectChanges();
    this.entidadeForm.get('mandatos')?.setValue(this.dataSet);
  }

  textoBotao(): string {
    switch (true) {
      case this.editar:
        return 'Editar';
      default:
        return 'Cadastrar';
    }
  }

  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.mandatoForm, campo);
  }
}
